const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
      paddingLeft: "1px 8px",
      backgroundColor: "#5382BA",
      justifyContent: "space-around",
      color: "#FFFFFF",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      fontWeight: 400,
      color: "#040018",
      backgroundColor: "#FFFFFF",
      
    },
    stripedStyle: {
      color: "#040018",
      backgroundColor: "#F9F9F9",
    },
  },
  subHeader: {
    style: {
      padding: "4px 0px 4px 0px",
    },
  },
};

export default tableCustomStyles;
